import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';
import { BaseRepo } from '@client/app/services/api/base-repo/base-repo';
import { PageModel } from '@client/app/models/page-model-factory.service';
import {
    LanguageMatchGetPagesParams,
    LanguageMatchGetSummaryParams,
    LanguageMatchGetSummaryResponse,
    LanguageMatchGetPageParams,
    LanguageMatchGetPageResponse,
} from './language-match-repo.type';

@Injectable({
    providedIn: 'root',
})
export class LanguageMatchRepoService extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    summary (params: LanguageMatchGetSummaryParams = {}): Promise<LanguageMatchGetSummaryResponse> {
        params = this.setGroupId(params);
        return this.apiService.getObservable(`domains/${this.getDomainId()}/language_match/summary`, params)
            .toPromise() as Promise<LanguageMatchGetSummaryResponse>;
    }

    pages (params: LanguageMatchGetPagesParams = {}): Promise<MonTableCollection<PageModel>> {
        params = this.setGroupId(params);
        return this.apiService.getObservable(`domains/${this.getDomainId()}/language_match/pages`, params)
            .toPromise() as Promise<MonTableCollection<PageModel>>;
    }

    page (pageId: number, params: LanguageMatchGetPageParams = {}): Promise<LanguageMatchGetPageResponse> {
        params = this.setGroupId(params);
        return this.apiService.getObservable(`domains/${this.getDomainId()}/pages/${pageId}/language_match`, params)
            .toPromise() as Promise<LanguageMatchGetPageResponse>;
    }
}

